var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{class:_vm.classes,attrs:{"no-caps":"","label":_vm.$t(_vm.text),"type":"submit","outline":"","loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }